import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBoxCosmeticBrandResponse } from './admin-box-cosmetic-brand.response';

@jsonObject
export class AdminBoxCosmeticResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(AdminBoxCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminBoxCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featureFile?: Nillable<MultimediaResponse>;
}
